<template>
  <cardTemplate :classCustom="'pCardReport clickable'">
    <template #default>
      <div class="header flex-row flex__left">
        <div class="margin-right-10">
          <img src="https://img.icons8.com/cute-clipart/52/000000/file.png"/>
        </div>
        <div
          class="rightSection width__100 padding-bottom-10 has-border__bottom"
        >
          <h3 class="tt1 clickable">Báo cáo văn bản theo sổ</h3>
        </div>
      </div>
      <div class="body margin-bottom-10 margin-top-10">
        <VuePerfectScrollbar
          class="scroll-body"
          :settings="perfectScrollbarSetting"
        >
          <div
            class="file-item flex-row flex-left margin-bottom-10 clickable"
            v-for="config in configs"
            :key="config.reportType"
            @click="viewReportDetail(config)"
          >
            <i
              class="far fa-file color__link font-size__small margin-bottom-10 margin-right-10"
            ></i>
            <span class="file-name has-border__bottom padding-bottom-10"
            >{{config.title}}</span
            >
          </div>
        </VuePerfectScrollbar>
      </div>
    </template>
  </cardTemplate>
</template>

<script>
  import constants from "../../constants";
  import utils from "../../services/utils";

  export default {
    name: "doc-in-book-report-card",
    components: {
      cardTemplate: () => import("../common/cardTemplate"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    data() {
      return {
        configs: [
          {
            title: "Báo cáo văn bản đến theo số",
            reportType: constants.REPORT.DOCINBOOK.TYPE.INCOMINGDOC_BYNUMBERRANGE
          },
          {
            title: "Báo cáo văn bản đến theo ngày",
            reportType: constants.REPORT.DOCINBOOK.TYPE.INCOMINGDOC_BYDATERANGE
          },
          {
            title: "Báo cáo văn bản đi theo số",
            reportType: constants.REPORT.DOCINBOOK.TYPE.OUTGOINGDOC_BYNUMBERRANGE
          },
          {
            title: "Báo cáo văn bản đi theo ngày",
            reportType: constants.REPORT.DOCINBOOK.TYPE.OUTGOINGDOC_BYDATERANGE
          }
        ]
      };
    },
    methods: {
      viewReportDetail(config) {
        let query = utils.merge(this.$route.query, {
          reportType: config.reportType
        });
        this.$router.push({
          name: "docInBookReport",
          params: this.$route.params,
          query: query
        });
      }
    }
  };
</script>

<style lang="css">
  .pCardReport {
    height: 300px;
    margin-bottom: 24px;
    padding: 0 10px;
  }

  .pCardReport .body {
    height: calc(100% - 105px);
  }

  .pCardReport .title {
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 12px;
  }

  .pCardReport .scroll-body {
    height: 100%;
  }

  .pCardReport .file-name {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/docInBookReportCard.vue